import { useState } from "react";
import Chat from "./Chat";
import Dashboard from "./Dashboard";

const COLORS = {
  navy: "#4A4031",
  gold: "#6B8E4E",
  lightGold: "#EDF2E4",
  white: "#FFFFFF",
  lightGray: "#F7F7F7",
  border: "#E0E0E0",
  text: "#2C2C2C",
};

export default function App() {
  const [page, setPage] = useState("dashboard");

  return (
    <div style={{ fontFamily: "Arial, sans serif", direction: "rtl", minHeight: "100vh", background: COLORS.lightGray }}>
      {/* Header */}
      <div style={{ background: COLORS.navy, padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 2px 8px rgba(0,0,0,0.2)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ color: COLORS.gold, fontSize: 22, fontWeight: "bold" }}>עסק חכם</span>
          <span style={{ color: "rgba(255,255,255,0.4)", fontSize: 18 }}>|</span>
          <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 13 }}>מערכת BI לדקל בע"מ</span>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {["dashboard", "chat"].map(p => (
            <button key={p} onClick={() => setPage(p)} style={{
              background: page === p ? COLORS.gold : "transparent",
              color: page === p ? COLORS.navy : COLORS.white,
              border: `1px solid ${page === p ? COLORS.gold : "rgba(255,255,255,0.3)"}`,
              borderRadius: 6,
              padding: "7px 18px",
              cursor: "pointer",
              fontWeight: page === p ? "bold" : "normal",
              fontSize: 14,
            }}>
              {p === "dashboard" ? "דשבורד" : "צ'אט"}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div>
        {page === "dashboard" ? <Dashboard /> : <Chat />}
      </div>
    </div>
  );
}
